import { render } from "./NoteSearchBar.vue?vue&type=template&id=b2c9db14&scoped=true"
import script from "./NoteSearchBar.vue?vue&type=script&lang=js"
export * from "./NoteSearchBar.vue?vue&type=script&lang=js"

import "./NoteSearchBar.vue?vue&type=style&index=0&id=b2c9db14&lang=scss&scoped=true"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c9db14"]])

export default __exports__